module.exports = __webpack_public_path__ + "yildizlar-sss-holding-logo.5bc799a54f3cf47a85cf.svg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/yildizlar-sss-holding-logo.svg
// module id = ../../../../../src/assets/img/yildizlar-sss-holding-logo.svg
// module chunks = main